/* eslint-disable @nx/enforce-module-boundaries */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@mybridge/ui/button';
// import { Input } from '@mybridge/ui/input';
import { Input, InputGroup, InputRightElement } from '@mybridge/ui/input';
import { updateUserPassword } from 'v4/store/slices/settingsSlice';
import { Box, Flex, Text, SimpleGrid, Spinner } from '@mybridge/ui';
// import { AddCircle, BackArrow, BackArrowRTL, EditIcon,OnlyMeLockIcon, } from '@mybridge/icons';
import { AddCircle, BackArrow, BackArrowRTL, EditIcon, OnlyMeLockIcon, EyeViewIcon, EyeViewFilledIcon } from '@mybridge/icons';
import { useToast } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import { IconButton } from '@mybridge/ui/icon-button';
import styles from './settings.module.scss';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { HStack } from '@chakra-ui/react';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

const Password = ({setIsEditing,setSelectedAccountComponent,setEditMode,editMode}) => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const direction = useDirection();
  const toast = useToast({
    position: 'top',
    isClosable: true,
    duration: 9000,
  });
  // TODO: Handle state/props/redux update and show a popup if error or success
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { updateStatus } = useSelector((state) => state.settings);

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (userProfileInfo?.id) {
      setValues(userProfileInfo);
    }

    return () => setValues({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fieldsOnChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const onClickSave = () => {
    setErrors({});
    const errorObject = {};
    const { oldPassword, newPassword, confirmPassword } = values;

    if (!oldPassword) {
      errorObject.oldPassword = t('settingAccount.pleaseEnterOldPassword') || 'Please enter old password';
    }
    if (!newPassword) {
      errorObject.newPassword = t('settingAccount.pleaseEnterNewPassword') || 'Please enter new password';
    }
    if (!confirmPassword) {
      errorObject.confirmPassword = t('settingAccount.pleaseEnterConfirmPassword') || 'Please enter confirmation password';
    }

    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      errorObject.passwordMatch = t('settingAccount.passwordMismatch') || 'Password and confirm password should match';
    }

    if (Object.keys(errorObject).length > 0) {
      setErrors(errorObject);
      return;
    }
    // else {
    //   setErrors({ errorFields, oldPassword: '', newPassword: '', confirmPassword: '' });
    // }

    dispatch(
      updateUserPassword({
        old_password: oldPassword,
        new_password: newPassword,
        verify_new_password: confirmPassword,
      })
    ).then((res) => {
      // if (res?.payload) {
      //   toast({
      //     title: res.payload?.message,
      //     status: 'success',
      //   });
      // }
      // setEditMode(false);
      // setIsEditing('')
      const payload = res?.payload;
      if (res?.error || (payload && payload.status_code && payload.status_code !== 200)) {
        let errorMessage = 'Error updating password';
        if (payload) {
          if (payload.password && Array.isArray(payload.password)) {
            errorMessage = payload.password[0];
          } else if (payload.new_password && Array.isArray(payload.new_password)) {
            errorMessage = payload.new_password[0];
          } else if (payload.message) {
            errorMessage = payload.message;
          } else if (payload.detail) {
            errorMessage = payload.detail;
          }
        } else if (res?.error?.message) {
          errorMessage = res.error.message;
        }
        
        toast({
          title: errorMessage,
          status: 'error',
        });
        return;
      }

      if (payload) {
        toast({
          title: payload?.message || 'Password updated successfully!',
          status: 'success',
        });
      }
      setValues((prev) => ({
        ...prev,
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      }));
      setEditMode(false);
      setIsEditing('');
    });
  };

  const onClickCancel = () => {
    setEditMode(false);
    setErrors({});
    setValues(userProfileInfo);
    setIsEditing("");
    setSelectedAccountComponent('account');
  };

  return (
    <Box my={['0px', '15px']}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        p={['10px', '0']}
      >
        {/* <Box w={['100%', '350px']}> */}
        <Box flex={1} maxW="350px" mr={4} minW="0">
          {isMobile && !editMode && (
            <>
              {/* <Box mt={3} display="flex" alignItems="center"> */}
              <Box mt={3} display="flex" alignItems="center" minW="0">
              <OnlyMeLockIcon width="24"
                      height="24" style={{ marginRight: '10px' }} color="#868585" />
              <Text color="#868585" fontSize={['15px']}>{t('settingAccount.changePassword') || "Change Password"} </Text>
              </Box>
              <Text color="#868585" fontSize={['12px']} ml="35px">
                {t('settingAccount.chooseUniquePassword') || "Choose a unique password to protect your account"}
              </Text>
            </>
          )}
          {!editMode && !isMobile && (
            <Box flex="1">
              {/* <Text color="brandGray.700">{t('settingAccount.changePassword') || "Change Password"}</Text> */}
              <Text color="brandGray.700" fontSize={['16px', '14px', '14px', '16px']}>{t('settingAccount.changePassword') || "Change Password"}</Text>
            </Box>
          )}
        </Box>
        {isMobile && !editMode ? (
          <IconButton
            bg="none"
            onClick={() => {
              setEditMode(true);
              setIsEditing('password');
              setSelectedAccountComponent('password');
            }}
            icon={<EditIcon />}
          />
        ) : (
          !editMode && (
            <Button
              variant="ghost"
              borderRadius={"30px"}
              color="black"
              onClick={() => {
                setEditMode(true);
                setIsEditing('password');
                setSelectedAccountComponent('password');
              }}
              leftIcon={<AddCircle width={20} height={20} />}
              fontSize={['14px', '13px', '13px', '14px']}
            >
              {t('settingAccount.changePassword') || "Change Password"}
            </Button>
          )
        )}
        {editMode && !isMobile && (
          <Box mt={3}>
            <hr />
          </Box>
        )}
      </Flex>
      {editMode && (
        <Box className="row g-0 justify-content-md-between" p={['10px', '0']}>
            <HStack>
              {!isMobile && <Button
                variant="transparent"
                leftIcon={direction === 'rtl' ? <BackArrowRTL color="#868585" /> : <BackArrow color="#868585" />}
                color="#868585"
                onClick={onClickCancel}
                p={0}
              />}
              <Text color="brandGray.700" fontSize={['20px', '16px']}>
                {t('settingAccount.changePassword') || "Change Password"}
              </Text>
            </HStack>
          <Text fontSize={['md', 'sm']} color="brandGray.700" mt="10px">
            {t('settingAccount.chooseUniquePassword') || "Choose a unique password to protect your account"}
          </Text>
          {isMobile ? (
            <Flex flexDirection="column" gap={3} mt='5%'>
              {/* <Input
                value={values.oldPassword}
                name="oldPassword"
                onChange={fieldsOnChange}
                type="password"
                placeholder={t('settingAccount.oldPassword') || "Old Password"}
                className={styles.dataDisplayBoxes}
              /> */}
              <InputGroup>
                <Input
                  value={values.oldPassword}
                  name="oldPassword"
                  onChange={fieldsOnChange}
                  type={showOldPassword ? 'text' : 'password'}
                  placeholder={t('settingAccount.oldPassword') || "Old Password"}
                  className={styles.dataDisplayBoxes}
                />
                <InputRightElement>
                  <IconButton
                    variant="transparent"
                    aria-label={showOldPassword ? 'Hide password' : 'Show password'}
                    icon={showOldPassword ? <EyeViewFilledIcon /> : <EyeViewIcon />}
                    onClick={() => setShowOldPassword(!showOldPassword)}
                  />
                </InputRightElement>
              </InputGroup>
              {/* <Input
                value={values.newPassword}
                name="newPassword"
                onChange={fieldsOnChange}
                type="password"
                placeholder={t('settingAccount.newPassword') || "New Password"}
                className={styles.dataDisplayBoxes}
              /> */}
              <InputGroup>
                <Input
                  value={values.newPassword}
                  name="newPassword"
                  onChange={fieldsOnChange}
                  type={showNewPassword ? 'text' : 'password'}
                  placeholder={t('settingAccount.newPassword') || "New Password"}
                  className={styles.dataDisplayBoxes}
                />
                <InputRightElement>
                  <IconButton
                    variant="transparent"
                    aria-label={showNewPassword ? 'Hide password' : 'Show password'}
                    icon={showNewPassword ? <EyeViewFilledIcon /> : <EyeViewIcon />}
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  />
                </InputRightElement>
              </InputGroup>
              {/* <Input
                value={values.confirmPassword}
                name="confirmPassword"
                onChange={fieldsOnChange}
                type="password"
                placeholder={t('settingAccount.confirmNewPassword') || "Confirm New Password"}
                className={styles.dataDisplayBoxes}
              /> */}
              <InputGroup>
                <Input
                  value={values.confirmPassword}
                  name="confirmPassword"
                  onChange={fieldsOnChange}
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder={t('settingAccount.confirmNewPassword') || "Confirm New Password"}
                  className={styles.dataDisplayBoxes}
                />
                <InputRightElement>
                  <IconButton
                    variant="transparent"
                    aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                    icon={showConfirmPassword ? <EyeViewFilledIcon /> : <EyeViewIcon />}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  />
                </InputRightElement>
              </InputGroup>
            </Flex>
          ) : (
            <SimpleGrid spacing={3} columns={1} my="10px" w="350px">
              {/* <Input
                value={values.oldPassword}
                name="oldPassword"
                onChange={fieldsOnChange}
                type="password"
                placeholder={t('settingAccount.oldPassword') || "Old Password"}
                variant="greyRounded"
              /> */}
              <InputGroup>
                <Input
                  value={values.oldPassword}
                  name="oldPassword"
                  onChange={fieldsOnChange}
                  type={showOldPassword ? 'text' : 'password'}
                  placeholder={t('settingAccount.oldPassword') || "Old Password"}
                  variant="greyRounded"
                />
                <InputRightElement>
                  <IconButton
                    variant="transparent"
                    aria-label={showOldPassword ? 'Hide password' : 'Show password'}
                    icon={showOldPassword ? <EyeViewFilledIcon /> : <EyeViewIcon />}
                    onClick={() => setShowOldPassword(!showOldPassword)}
                  />
                </InputRightElement>
              </InputGroup>
              {/* <Input
                value={values.newPassword}
                name="newPassword"
                onChange={fieldsOnChange}
                type="password"
                placeholder={t('settingAccount.newPassword') || "New Password"}
                variant="greyRounded"
              /> */}
              <InputGroup>
                <Input
                  value={values.newPassword}
                  name="newPassword"
                  onChange={fieldsOnChange}
                  type={showNewPassword ? 'text' : 'password'}
                  placeholder={t('settingAccount.newPassword') || "New Password"}
                  variant="greyRounded"
                />
                <InputRightElement>
                  <IconButton
                    variant="transparent"
                    aria-label={showNewPassword ? 'Hide password' : 'Show password'}
                    icon={showNewPassword ? <EyeViewFilledIcon /> : <EyeViewIcon />}
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  />
                </InputRightElement>
              </InputGroup>
              {/* <Input
                value={values.confirmPassword}
                name="confirmPassword"
                onChange={fieldsOnChange}
                type="password"
                placeholder={t('settingAccount.confirmNewPassword') || "Confirm New Password"}
                variant="greyRounded"
              /> */}
              <InputGroup>
                <Input
                  value={values.confirmPassword}
                  name="confirmPassword"
                  onChange={fieldsOnChange}
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder={t('settingAccount.confirmNewPassword') || "Confirm New Password"}
                  variant="greyRounded"
                />
                <InputRightElement>
                  <IconButton
                    variant="transparent"
                    aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                    icon={showConfirmPassword ? <EyeViewFilledIcon /> : <EyeViewIcon />}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  />
                </InputRightElement>
              </InputGroup>
            </SimpleGrid>
          )}
          <Box>
            {errors.oldPassword && (
              <div className="text-danger">{errors.oldPassword}</div>
            )}
            {errors.newPassword && (
              <div className="text-danger">{errors.newPassword}</div>
            )}
            {errors.confirmPassword && (
              <div className="text-danger">{errors.confirmPassword}</div>
            )}
            {errors.passwordMatch && (
              <div className="text-danger">{errors.passwordMatch}</div>
            )}
          </Box>
          <Flex
            justifyContent={isMobile ? 'flex-end' : 'flex-start'}
            columnGap="2"
            mt={['5%','2%']}
          >
            <Button onClick={onClickCancel} borderRadius={['30px','30px']} bg='#E4E6EB'>{t('buttons.cancel') || "Cancel"}</Button>
            <Button
              disabled={updateStatus === 'pending'}
              onClick={onClickSave}
              color="#fff"
              bg={['#3D5A80', '#3D5A80']}
              borderRadius={['30px','30px']}
            >
              {updateStatus === 'pending' ? <Spinner /> : t('buttons.save') || 'Save'}
            </Button>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default Password;
